import { Capitalize, Pluralize } from "../functions/Formatters";
import { appName, global } from "./global";

export const titleBar = {
    title: appName.full,
    logout: "Uitloggen",
    login: "Inloggen",
    profile: "Profiel",
    projects: "Projecten",
    themes: Capitalize(Pluralize(global.theme)),
    admin: "Applicatie",
    loggedInAs: "Ingelogd als:",
};
